import {
  SET_ROUTE_NAME,
  SET_ROUTE_EIRCODE,
  SET_ROUTE_HIGHWAY,
  SET_ROUTE_REL_ALT,
  SET_ROUTE_TYPE,
  CREATING_ROUTE_REQUEST,
  CREATING_ROUTE_SUCCESS,
  CREATING_ROUTE_FAILURE,
  UPDATING_ROUTE_REQUEST,
  UPDATING_ROUTE_SUCCESS,
  UPDATING_ROUTE_FAILURE,
  DELETE_ROUTE_REQUEST,
  DELETE_ROUTE_SUCCESS,
  DELETE_ROUTE_FAILURE,
  ENABLE_ROUTE_REQUEST,
  ENABLE_ROUTE_FAILURE,
  ENABLE_ROUTE_SUCCESS,
  TOGGLE_NEW_LINE_AND_POINTS,
  TOGGLE_UPDATE_LINE_AND_POINTS,
  FETCH_ROUTES_REQUEST,
  FETCH_ROUTES_SUCCESS,
  FETCH_ROUTES_FAILURE,
  SET_UPDATE_GEOJSON,
  SET_UPDATE_ROUTE,
  CLEAR_UPDATE_ROUTE,
  SET_NEW_ROUTE,
  SET_NEW_GEOJSON,
  CLEAR_NEW_ROUTE,
  SHOW_DELETE_CONFIRM,
  CLOSE_DELETE_CONFIRM,
  SET_TAB,
  SET_NEW_ROUTE_START_POINT,
  SET_NEW_ROUTE_START_POINT_ELEVATION,
  SET_NEW_ROUTE_ELEVATION_POINTS,
  SET_UPDATE_ROUTE_ELEVATION_POINTS,
  SET_UPDATE_ROUTE_START_POINT,
  SET_UPDATE_ROUTE_START_POINT_ELEVATION,
  SET_DRONE_ALTITUDE_PATH,
  SET_DRONE_ELEVATION_PATH,
  SET_UPDATE_ROUTE_REL_ALT,
  FETCH_ROUTE_QR_CODE,
  FETCH_ROUTE_QR_CODE_SUCCESS,
  GET_ALL_ADDRESS_LOCATIONS,
  FETCH_ROUTE_QR_CODE_FAILURE,
  SET_DISABLE_SLOPED_ASCENT,
  SET_DROP_LOCATION,
  ADD_SELECTED_HEXES,
  CLEAR_OBSTACLES_SELECTED,
  SET_OBSTACLE_TYPE,
  SET_EXISTING_OBSTACLES,
  CLEAR_ALL_OBSTACLES_AND_REGION,
  SET_OBSTACLES_REGION,
  LOADING_OBSTACLES_REGION,
  SET_SAVING_OBSTACLES,
  SET_HAS_DELETED_OBSTACLE
} from 'actions/actionTypes';

const newRouteGeoJson = JSON.stringify(
  { type: 'FeatureCollection', features: [] },
  null,
  2
);

const defaultState = {
  creatingRoute: false,
  routeEircode: '',
  routeName: '',
  routeType: 'STANDARD',
  relAlt: false,
  disableSlopedAscent: false,
  updateRouteRelAlt: false,
  highwayKey: '',
  routesKeys: [],
  newRouteGeoJson,
  newShowLine: true,
  updateShowLine: true,
  fetchingRoutes: true,
  tab: 0,
  newRouteElevationPoints: [],
  newRouteStartPointElevation: false,
  newRouteStartPoint: false,
  updateRouteElevationPoints: [],
  updateRouteStartPointElevation: false,
  updateRouteStartPoint: false,
  dropLocation: null,
  obstacles: {},
  selectedHexes: [],
  userAddressLocations: []
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_ROUTE_EIRCODE: {
      return {
        ...state,
        routeEircode: action.payload
      };
    }
    case SET_ROUTE_NAME: {
      return {
        ...state,
        routeName: action.payload
      };
    }
    case SET_ROUTE_TYPE: {
      return {
        ...state,
        routeType: action.payload
      };
    }
    case SET_ROUTE_REL_ALT: {
      return {
        ...state,
        relAlt: action.payload
      };
    }
    case SET_UPDATE_ROUTE_REL_ALT: {
      return {
        ...state,
        updateRouteRelAlt: action.payload
      };
    }
    case SET_ROUTE_HIGHWAY: {
      return {
        ...state,
        highwayKey: action.payload
      };
    }
    case CREATING_ROUTE_REQUEST: {
      return {
        ...state,
        creatingRoute: true
      };
    }
    case CREATING_ROUTE_SUCCESS: {
      return {
        ...state,
        creatingRoute: false,
        newRouteGeoJson: JSON.stringify(action.payload.misc1, null, 2),
        newRoute: action.payload,
        newShowLine: false
      };
    }
    case CREATING_ROUTE_FAILURE: {
      return {
        ...state,
        creatingRoute: false
      };
    }
    case UPDATING_ROUTE_REQUEST: {
      return {
        ...state,
        updatingRoute: true
      };
    }
    case UPDATING_ROUTE_SUCCESS: {
      return {
        ...state,
        updatingRoute: false,
        updateRouteGeoJson: JSON.stringify(action.payload.misc1, null, 2),
        updateRoute: action.payload,
        updateShowLine: false
      };
    }
    case UPDATING_ROUTE_FAILURE: {
      return {
        ...state,
        updatingRoute: false
      };
    }
    case DELETE_ROUTE_REQUEST: {
      return {
        ...state,
        deletingRoute: true
      };
    }
    case DELETE_ROUTE_SUCCESS: {
      const newRoutesKeys = state.routesKeys;
      const newRoutes = state.routes;
      newRoutesKeys.splice(newRoutesKeys.indexOf(action.payload), 1);
      delete newRoutes[action.payload];
      return {
        ...state,
        deletingRoute: false,
        openDeleteConfirm: false,
        updateRouteGeoJson: null,
        updateRoute: null,
        routesKeys: newRoutesKeys,
        deleteId: null,
        deleteEircode: null
      };
    }
    case DELETE_ROUTE_FAILURE: {
      return {
        ...state,
        deletingRoute: false,
        openDeleteConfirm: false,
        deleteId: null,
        deleteEircode: null
      };
    }
    case ENABLE_ROUTE_REQUEST: {
      return {
        ...state,
        enablingRoute: true
      };
    }
    case ENABLE_ROUTE_SUCCESS: {
      return {
        ...state,
        routes: { ...state.routes, [action.payload.eircode]: action.payload },
        enablingRoute: false
      };
    }
    case ENABLE_ROUTE_FAILURE: {
      return {
        ...state,
        enablingRoute: false
      };
    }
    case FETCH_ROUTES_REQUEST: {
      return {
        ...state,
        fetchingRoutes: true
      };
    }
    case FETCH_ROUTES_SUCCESS: {
      return {
        ...state,
        routesKeys: action.payload.routesKeys,
        highwayKeys: action.payload.highwayKeys,
        routes: action.payload.routes,
        fetchingRoutes: false
      };
    }
    case FETCH_ROUTES_FAILURE: {
      return {
        ...state,
        fetchingRoutes: false
      };
    }
    case SET_NEW_GEOJSON: {
      return {
        ...state,
        newRouteGeoJson: action.payload
      };
    }
    case SET_NEW_ROUTE: {
      return {
        ...state,
        newRoute: action.payload
      };
    }
    case CLEAR_NEW_ROUTE: {
      return {
        ...state,
        newRouteGeoJson,
        routeEircode: '',
        routeName: '',
        routeType: 'STANDARD',
        highwayKey: '',
        relAlt: false,
        newRoute: null
      };
    }
    case SET_UPDATE_GEOJSON: {
      return {
        ...state,
        updateRouteGeoJson: action.payload
      };
    }

    case SET_UPDATE_ROUTE: {
      return {
        ...state,
        updateRoute: action.payload
      };
    }
    case CLEAR_UPDATE_ROUTE: {
      return {
        ...state,
        updateRouteGeoJson: null,
        updateRoute: null,
        updateRouteStartPoint: null,
        updateRouteStartPointElevation: null,
        updateRouteElevationPoints: false
      };
    }
    case TOGGLE_NEW_LINE_AND_POINTS: {
      return {
        ...state,
        newShowLine: action.payload
      };
    }
    case TOGGLE_UPDATE_LINE_AND_POINTS: {
      return {
        ...state,
        updateShowLine: action.payload
      };
    }
    case SHOW_DELETE_CONFIRM: {
      return {
        ...state,
        openDeleteConfirm: true,
        deleteId: action.payload.id,
        deleteEircode: action.payload.eircode
      };
    }
    case CLOSE_DELETE_CONFIRM: {
      return {
        ...state,
        openDeleteConfirm: false,
        deleteId: null,
        deleteEircode: null
      };
    }
    case SET_TAB: {
      return {
        ...state,
        tab: action.payload
      };
    }
    case SET_NEW_ROUTE_ELEVATION_POINTS: {
      return {
        ...state,
        newRouteElevationPoints: action.payload
      };
    }
    case SET_NEW_ROUTE_START_POINT: {
      return {
        ...state,
        newRouteStartPoint: action.payload
      };
    }
    case SET_NEW_ROUTE_START_POINT_ELEVATION: {
      return {
        ...state,
        newRouteStartPointElevation: action.payload
      };
    }
    case SET_UPDATE_ROUTE_ELEVATION_POINTS: {
      return {
        ...state,
        updateRouteElevationPoints: action.payload
      };
    }
    case SET_UPDATE_ROUTE_START_POINT: {
      return {
        ...state,
        updateRouteStartPoint: action.payload
      };
    }
    case SET_UPDATE_ROUTE_START_POINT_ELEVATION: {
      return {
        ...state,
        updateRouteStartPointElevation: action.payload
      };
    }
    case SET_DRONE_ALTITUDE_PATH: {
      return {
        ...state
      };
    }
    case SET_DRONE_ELEVATION_PATH: {
      return {
        ...state
      };
    }
    case SET_DISABLE_SLOPED_ASCENT: {
      return {
        ...state,
        disableSlopedAscent: action.payload
      };
    }
    case FETCH_ROUTE_QR_CODE: {
      return {
        ...state,
        loadingQRCode: true,
        qrCodeError: false
      };
    }
    case FETCH_ROUTE_QR_CODE_SUCCESS: {
      return {
        ...state,
        loadingQRCode: false,
        qrCode: action.payload,
        qrCodeError: false
      };
    }
    case GET_ALL_ADDRESS_LOCATIONS: {
      return {
        ...state,
        userAddressLocations: action.payload
      };
    }
    case FETCH_ROUTE_QR_CODE_FAILURE: {
      return {
        ...state,
        loadingQRCode: false,
        qrCodeError: true,
        qrCode: false
      };
    }
    case SET_DROP_LOCATION: {
      return {
        ...state,
        dropLocation: action.payload
      };
    }
    case LOADING_OBSTACLES_REGION: {
      return {
        ...state,
        loadingObstaclesRegion: action.payload
      };
    }
    case CLEAR_OBSTACLES_SELECTED: {
      return {
        ...state,
        selectedHexes: []
      };
    }
    case ADD_SELECTED_HEXES: {
      return {
        ...state,
        selectedHexes: action.payload
      };
    }
    case SET_OBSTACLES_REGION: {
      return {
        ...state,
        obstacleRegion: action.payload.regionHex,
        regionId: action.payload.regionId
      };
    }
    case SET_OBSTACLE_TYPE: {
      return {
        ...state,
        currentObstacleType: action.payload
      };
    }
    case SET_EXISTING_OBSTACLES: {
      return {
        ...state,
        existingObstaclesSet: true,
        obstacles: action.payload,
        loadingObstaclesRegion: false,
        obstaclesKey: Math.random(),
        savingObstacles: false,
        selectedHexes: []
      };
    }
    case CLEAR_ALL_OBSTACLES_AND_REGION: {
      return {
        ...state,
        existingObstaclesSet: false,
        selectedHexes: [],
        obstacles: {},
        obstaclesKey: Math.random(),
        obstacleRegion: false,
        regionId: false
      };
    }
    case SET_SAVING_OBSTACLES: {
      return {
        ...state,
        savingObstacles: true
      };
    }
    case SET_HAS_DELETED_OBSTACLE: {
      return {
        ...state,
        hasDeletedObstacle: action.payload
      };
    }
    default:
      return state;
  }
};
